export const APP_VERSION_KEY = 'app_version';
export const UPDATE_REQUIRED_KEY = 'app_update_required';
export const LAST_FORCED_VERSION_KEY = 'last_forced_logout_version';